import React from "react";
import ReactExport from "../vendors/react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excel = ({
  filename,
  data,
  columns,
  name,
  refs,
  totalData,
  totalColumns,
}) => (
  <ExcelFile ref={refs} filename={filename} element={<span />}>
    <ExcelSheet data={data} name={name}>
      {columns.map(({ label, value }) => (
        <ExcelColumn key={value} label={label} value={value} />
      ))}
    </ExcelSheet>
    <ExcelSheet data={totalData} name={"Totals"}>
      {totalColumns.map(({ label, value }) => (
        <ExcelColumn key={value} label={label} value={value} />
      ))}
    </ExcelSheet>
  </ExcelFile>
);

Excel.defaultProps = {
  name: "Sheet Title",
  filename: "connect to fit",
  totalData: [],
  totalColumns: [],
};

export default Excel;